'use strict';

var global = {
    getInstance: function getInstance() {
        return window;
    },
    getConstructor: function getConstructor() {
        return Window;
    },
    getOrigin: function getOrigin() {
        var origin = window.location.origin;
        if (!origin) {
            origin = window.location.protocol + '//' + window.location.hostname + (window.location.port ? ':' + window.location.port : '');
        }
        return origin;
    },
    getProtocol: function getProtocol() {
        var protocol = window.location.protocol;
        return protocol;
    },
    getHref: function getHref() {
        var href = window.location.href;
        return href;
    },
    getUserAgent: function getUserAgent() {
        return window.navigator.userAgent;
    }
};

module.exports = global;


//////////////////
// WEBPACK FOOTER
// ./~/@dp/owl/lib/util/global.js
// module id = 100
// module chunks = 0